module.exports = __webpack_public_path__ + "img/email.46e5868.svg";